import { FunctionComponent } from 'react';
import styles from './DropDownItem.module.scss';
import clsx from 'clsx';
import Avatar from './Avatar';

interface DropDownItemProps {
    avatar: string | null;
    staffName: string | null;
    className?: string;
    onClick?: () => void;
}

export const DropDownItem: FunctionComponent<DropDownItemProps> = props => {
    return (
        <div
            className={clsx(styles.container, props.className)}
            onClick={props.onClick}
        >
            <Avatar
                imageUrl={props.avatar}
                className={styles.avatar}
            />
            <span className={styles.name}>{props.staffName || 'Unassigned'}</span>
        </div>
    );
};

export default DropDownItem;
